import React from 'react';
import BanjoFretboard from './BanjoFretboard';

function App() {
  return (
    <div className="App">
      <BanjoFretboard />
    </div>
  );
}

export default App;
